import MembershipSettingsTable from './MembershipSettingsTable';

export default MembershipSettingsTable;
